import { all, put, takeEvery } from "redux-saga/effects";
import { errorWorker } from "../utilities/errors";
import { priceTagConstants } from "../constants/priceTagConstants";
import priceTagService from "../services/priceTagService";

function* getPriceTags(action: any) {
  try {
    const { data } = yield priceTagService.getPriceTags(action.payload);
    if (!data.data) return;
    yield put({
      type: priceTagConstants.SET_PRICE_TAGS,
      payload: {
        priceTags: data.data.price_tags,
      },
    });
  } catch (error) {
    yield put(errorWorker(error));
  }
}

function* priceTagWatcher() {
  yield takeEvery(priceTagConstants.GET_PRICE_TAGS, getPriceTags);
}

export default function* rootpriceTagSaga() {
  yield all([priceTagWatcher()]);
}
